<div class="card-body flex flex-col">
  <div class="card-title mb-5">
    <div class="flex justify-between items-center mb-5">
      <span class="text-xl font-bold text-primary">
        {{ "CASE_DETAIL.ACTIONS" | translate }}
      </span>
    </div>
    <hr />
  </div>
  @if (claimStatus!='Approved' && claimStatus!='Rejected') {
  <div class="flex flex-col gap-y-4">
    @if(currentUser.role === roles.Administrator && api.includes('coassess')){
    <div>
      <span class="text-dark">
        {{ "CASE_DETAIL.ASSIGN_MANAGER" | translate }}
      </span>
      <div class="flex flex-col xl:flex-row items-center justify-between w-full gap-2">
        <p-select [options]="caseManagerOptions()" optionLabel="label" optionValue="value" filter="true" [placeholder]="
            caseData.caseManager
              ? caseData.caseManager
              : ('CASE_DETAIL.SELECT_A_MANAGER' | translate)
          " appendTo="body" [(ngModel)]="selectedCaseManagerId" class="w-full min-w-0 whitespace-normal"></p-select>
        <button id="assignManager" pButton [severity]="'primary'" class="!text-white !w-[100px]"
          (click)="onAssign(selectedCaseManagerId.toString())" [disabled]="selectedCaseManagerId === 0">
          {{ "CASE_DETAIL.ASSIGN" | translate }}
        </button>
      </div>
    </div>
    }@else {
    <div>
      <span class="text-dark">
        {{ "CASE_DETAIL.ADJUSTER" | translate }}
      </span>

      <div class="w-full p-2 border rounded bg-gray-100 text-gray-800">
        {{ caseData.adjuster || ('CASE_DETAIL.NO_ADJUSTER' | translate) }}
      </div>
    </div>
    }
    @if (api.includes('coreact') || api.includes('localhost')) {
    <div>
      <span class="text-dark">
        {{ "CASE_DETAIL.ASSESSORS" | translate }}
      </span>

      <div class="flex flex-col xl:flex-row items-center justify-between w-full gap-2">
          <p-listbox [options]="assessorOptions()" optionLabel="label" optionValue="value" [emptyMessage]="'CASE_DETAIL.NO_ASSESSORS_FOUND' | translate">
          </p-listbox>

          <button pButton [severity]="'primary'" class="!text-white !w-[100px]"
            (click)="onAssignAssessor(selectedAssessorId.toString())" [disabled]="true">
            {{ "CASE_DETAIL.ASSIGN" | translate }}
        </button>
      </div>
    </div>
    }

    @if(canAssignInvestigator){
    <div>
      <span class="text-dark">
        {{ "CASE_DETAIL.ASSIGN_INVESTIGATOR" | translate }}
      </span>
      <div class="flex flex-col xl:flex-row items-center justify-between w-full gap-2">
        <p-select [options]="investigatorOptions()" optionLabel="label" optionValue="value" filter="true" [placeholder]="
            caseData.investigator
              ? caseData.investigator
              : ('CASE_DETAIL.SELECT_AN_INVESTIGATOR' | translate)
          " appendTo="body" [(ngModel)]="selectedInvestigatorId" class="w-full min-w-0 whitespace-normal"></p-select>
        @if (api.includes('coassess')) {
        <button id="assignInvestigator" pButton [severity]="'primary'" class="!text-white !w-[100px]"
          (click)="onAssign(selectedInvestigatorId.toString())" [disabled]="selectedInvestigatorId === 0">
          {{ "CASE_DETAIL.ASSIGN" | translate }}
        </button>
        } @else {
        <button id="assignInvestigator" pButton [severity]="'primary'" class="!text-white !w-[100px]"
          (click)="onAssignInvestigator(selectedInvestigatorId.toString())" [disabled]="selectedInvestigatorId === 0">
          {{ "CASE_DETAIL.ASSIGN" | translate }}
        </button>
        }
      </div>
    </div>
    @if (api.includes('coreact') || api.includes('localhost')) {
    <div class="flex justify-center mb-4">
      <button
        pButton
        severity="secondary"
        class="!w-[150px]"
        (click)="clearAssignments()">
        {{ 'CASE_DETAIL.CLEAR_ASSIGNMENTS' | translate }}
      </button>
    </div>}
    }
    @if (isCoassess) {
    <div>
      <span class="text-dark">
        {{ "CASE_DETAIL.CHANGE_INVESTIGATION_STATUS" | translate }}
      </span>
      <div class="flex flex-col xl:flex-row items-center justify-between w-full gap-2">
        <p-select [options]="statusOptions()" optionLabel="label" optionValue="value" filter="true"
          [placeholder]="'CASE_DETAIL.SELECT_A_STATUS' | translate" appendTo="body" [(ngModel)]="selectedStatus"
          class="w-full min-w-0 whitespace-normal"></p-select>
        <button id="changeCaseStatus" class="!text-white !w-[100px]" pButton [severity]="'primary'"
          (click)="onChangeCaseStatus(selectedStatus)" [disabled]="!selectedStatus">
          {{ "CASE_DETAIL.CHANGE" | translate }}
        </button>
      </div>
    </div>
    }
    @if(!isCaseDetailReadOnly && (currentUser.role == roles.Administrator
    || currentUser.role == roles.CaseManager
    || currentUser.role == roles.Investigator)){
    <div>
      <div class="border border-dotted border-primary rounded-xl text-center">
        <div class="p-3">
          <button pButton [disabled]="isButtonDisabledInvestigation" [size]="'large'" [severity]="'warn'"
            class="w-full text-white" (click)="showInvestigationResultModal.set(true)">
            {{ "CASE_DETAIL.ADD_INVESTIGATION_RESULT" | translate }}
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  } @else if(claimStatus=='Approved' || claimStatus=='Rejected') {
  <div class="text-center">
    <span class="text-muted">
      {{ "CASE_DETAIL.NO_ACTIONS_AVAILABLE" | translate }}
    </span>
  </div>
  }
  @if(showInvestigationResultModal() && !isCaseDetailReadOnly){
  <lib-investigation-result-modal [header]="'CASE_DETAIL.ADD_COMMENTS' | translate"
    [(showModal)]="showInvestigationResultModal" [selectedInvestigationResult]="selectedInvestigationResult"
    [investigationStatuses]="investigationStatuses" [showChips]="false"
    (onSubmit)="createTemporaryInvestigationComment($event)" [savedAmount]="caseData.savedAmount"
    (savedAmountChange)="handleSavedAmount($event)" (onFileUpload)="handleFilesToUpload($event)"
    (onFileRemove)="onRemoveFile($event)" />
  }

  <p-confirmdialog>
    <ng-template #message let-message>
      <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
        <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
        <p>{{ message.message }}</p>
      </div>
    </ng-template>
  </p-confirmdialog>
</div>
<p-toast baseZIndex="100000" position="center" />